<template>
  <Portal to="app-dialog">
    <VModal ref="modal" @modal:hidden="$emit('close')" disable-backdrop-click>
      <div class="w-full max-w-lg mx-auto">
        <div class="rounded shadow-xs w-full max-w-6xl mx-auto" @click.stop>
          <div class="rounded shadow-lg bg-white overflow-hidden divide-y divide-gray-200">
            <div class="p-4">
              <BaseFormTextarea v-model="inputContent" rows="10" />
            </div>
            <div class="p-4 flex space-x-2">
              <BaseButton primary @click="handleUpdate"> Update </BaseButton
              ><BaseButton ghost @click="$refs.modal.close()"> Cancel </BaseButton>
            </div>
          </div>
        </div>
      </div>
    </VModal>
  </Portal>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      inputContent: this.content,
    };
  },
  watch: {
    content(newContent) {
      this.inputContent = newContent;
    },
  },
  methods: {
    handleUpdate() {
      this.$emit('update', this.inputContent);
      this.$refs.modal.close();
    },
  },
};
</script>
